import { useSelector } from "react-redux";
import type { RootState } from "../store/store";
import { selectQlikObjectByName } from "../store/slice/qlikObjectSlice";

export function useReady(appName: string = "", hyperCubeCustomId: string = "", vizName: string = "", fieldName: string = "") {
  // const resourcesReady = useSelector((state: RootState) => state.qlikResources.loadComplete);
  // const selectionsApplied = useSelector((state: RootState) => state.selection.isPageSelectionApplied);
  //Controlling whether the generic objects for app and view are already created or not
  const hyperCubeDataCustomId = useSelector((state: RootState) => state.qlikObject.qlikHyperCubesData[appName]?.hyperCubeCustomIds.includes(hyperCubeCustomId));
  //Controlling whether the kpi objects are already created or not
  const qlikObject = useSelector((state: RootState) => selectQlikObjectByName(state, vizName))
  //Controlling whether the qlikFields are already created or not
  const qlikFields = useSelector((state: RootState) => state.qlikFields.qlikFieldsValList[appName]?.[fieldName]);

  // let ready = false;
  // if (resourcesReady && selectionsApplied) {
  //   ready = true;
  // }

  // return { ready, resourcesReady, genericObjectsView, kpiObjects, qlikFields }
  return { qlikFields, qlikObject, hyperCubeDataCustomId }
}